import { FormControl, NativeSelect } from '@mui/material';
import { useEffect, useState } from 'react';
import { Icon24UtilityChevron } from '@care/react-icons';
import { FilterButton } from '@care/react-component-lib';
import { AmplitudeEvent, trackAmplitudeEvent } from '@/lib/analyticsHelper';
import { AVAILABILITIES } from '@/constants';
import { saveFilters } from '../../../utils/filtersStorage';

interface Props {
  isClear: Boolean;
  onChange(): void;
  handleClick(): void;
}

const Availability = (props: Props) => {
  const { handleClick, isClear, onChange } = props;

  const [available, setAvailable] = useState({
    availability: '',
  });
  const iconComponent = () => (
    <Icon24UtilityChevron component="select" height="20px" width="20px" />
  );

  const options = AVAILABILITIES.map((availability) => (
    <option key={availability.label} value={availability.value}>
      {availability.label}
    </option>
  ));
  const handleApply = () => {
    saveFilters(
      {
        availability: available.availability === '' ? null : available.availability,
      },
      onChange
    );

    const amplitudeData = {
      availability: available.availability,
    };

    trackAmplitudeEvent(AmplitudeEvent.applySegmentationFilter, amplitudeData);
  };

  useEffect(() => {
    if (isClear) {
      setAvailable({ availability: '' });
    }
  }, [isClear]);

  return (
    <FilterButton
      field="Availability"
      label="Availability"
      selected={available.availability !== ''}
      onApply={handleApply}
      onClick={handleClick}
      sx={{ color: 'text.primary' }}>
      <FormControl variant="standard" sx={{ width: '325px' }}>
        <NativeSelect
          fullWidth
          onChange={(e) => setAvailable({ ...available, availability: e.target.value })}
          inputProps={{
            name: 'option',
            id: 'field-native-select',
          }}
          value={available.availability}
          IconComponent={iconComponent}>
          {options}
        </NativeSelect>
      </FormControl>
    </FilterButton>
  );
};

export default Availability;
